import { Radio } from '../../../../../common/html/radio'
import { Image } from '../../../../../common/image'
import { BANK_TRANSFER_TYPE } from '../constants'
import classes from './index.module.scss'
import onePay from './onePay.png'

export const Card = ({ bankTransferType, setBankTransferType }) => {
  return (
    <div className={classes.bankTransferContainer}>
      {Object.values(BANK_TRANSFER_TYPE).map((key) => {
        return (
          <Radio
            key={key}
            isI18n={false}
            title={
              <Image
                src={onePay}
                alt="bankTransferMethod"
                style={{
                  width: 85,
                  height: 36,
                }}
              />
            }
            mlTitle={27}
            inputStyle={{
              width: 17,
              height: 17,
              borderWidth: '2px',
              borderRadius: '50%',
            }}
            value={key}
            activeValue={bankTransferType}
            onChange={() => setBankTransferType(key)}
          />
        )
      })}
    </div>
  )
}
